import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e260101"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "introductory-videos__background" }, null, -1))
const _hoisted_2 = { class: "introductory-videos__content" }
const _hoisted_3 = { class: "introductory-videos__header" }
const _hoisted_4 = { class: "introductory-videos__modal" }
const _hoisted_5 = ["id", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "introductory-videos",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "introductory-videos__button-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("iframe", {
          class: "introductory-videos__iframe",
          id: _ctx.introductoryContent?.id,
          src: 
            `https://www.youtube.com/embed/${_ctx.introductoryContent?.youtube?.code}?autoplay=1&rel=0&modestbranding=1`
          ,
          title: "YouTube video player",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        }, null, 8, _hoisted_5)
      ])
    ])
  ]))
}